import {StableToChoose} from 'api/gen/StableToChoose';

/**
 * Builds the cow-browser route for a selected stable row.
 *
 * @param row Stable row selected on the overview table.
 * @returns The cow-browser route for the stable.
 */
export const getCowTableLink = (row: StableToChoose): string => `/animal-browser/cow-browser/${row.id}`;
